module.exports = __webpack_public_path__ + "static/scale-model-of-knott-house-museum-in-tallahassee-florida-5986455a8fcfb7d97b1a477073caf71c.png";